import { Card, CardColor, CardType } from './types'
import { Language, t } from './data/translations'

export const INITIAL_HEALTH = 15
export const HAND_SIZE = 99
export const MAX_PREPARED_CARDS = 5
export const ABSOLUTE_MAX_PREPARED_CARDS = 12

export const DECK_COMPOSITION: Omit<Card, 'id'>[] = [
  ...Array(4).fill({ type: CardType.Attack, value: 1, typeB: CardType.Pushback, valueB: 1, color: CardColor.Red }),
  ...Array(2).fill({ type: CardType.Attack, value: 1, typeB: CardType.Pushback, valueB: 1, color: CardColor.Red }),
  ...Array(2).fill({ type: CardType.Attack, value: 1, typeB: CardType.Pushback, valueB: 1, color: CardColor.Red }),
  ...Array(8).fill({ type: CardType.Heal, value: 1, typeB: CardType.Disease, valueB: 1, color: CardColor.Green }),
  ...Array(8).fill({ type: CardType.PsySearch, value: 2, typeB: CardType.PsyBlock, valueB: 1, color: CardColor.Black }),
  ...Array(8).fill({ type: CardType.Steal, value: 1, typeB: CardType.DoubleCross, valueB: 1, color: CardColor.Purple }),
  ...Array(8).fill({ type: CardType.Energize, value: 2, typeB: CardType.Shock, valueB: 2, color: CardColor.Yellow }),
  ...Array(8).fill({ type: CardType.Hibernation, value: 1, typeB: CardType.Dispel, valueB: 1, color: CardColor.Pink }),
]

export const STASH_DECK_COMPOSITION: Omit<Card, 'id' | 'color'>[] = [
  ...Array(1).fill({ type: CardType.Attack, value: 5, essenceCost: 6, subType: 'Armory', faceSlug: 'ancient-sword' }),
  ...Array(1).fill({ type: CardType.Chromabow, value: 4, essenceCost: 6, subType: 'Armory', faceSlug: 'chromabow' }),
  ...Array(1).fill({ type: CardType.Defense, value: 5, essenceCost: 6, subType: 'Armory', extendedShield: true, faceSlug: 'ancient-shield' }),
  ...Array(1).fill({ type: CardType.Defense, value: 2, essenceCost: 5, subType: 'Armory', extendedShield: true, faceSlug: 'shimmering-shield' }),
  ...Array(1).fill({ type: CardType.Defense, value: 2, essenceCost: 2, subType: 'Armory', extendedShield: true, faceSlug: 'steel-shield' }),
  ...Array(1).fill({ type: CardType.Defense, value: 0, essenceCost: 6, subType: 'Armory', extendedShield: true, faceSlug: 'spikes' }),
  ...Array(1).fill({ type: CardType.EnergySword, value: 2, essenceCost: 4, subType: 'Armory', faceSlug: 'energy-sword' }),
  ...Array(1).fill({ type: CardType.FlyingScythe, value: 2, essenceCost: 6, subType: 'Armory', faceSlug: 'flying-scythe' }),
  ...Array(1).fill({ type: CardType.InfernoGauntlet, value: 4, essenceCost: 6, subType: 'Armory', faceSlug: 'inferno-gauntlet' }),
  ...Array(1).fill({ type: CardType.Larcendagger, value: 3, essenceCost: 6, subType: 'Armory', faceSlug: 'larcendagger' }),
  ...Array(1).fill({ type: CardType.Attack, value: 3, essenceCost: 4, subType: 'Armory', faceSlug: 'the-sting' }),
  ...Array(1).fill({ type: CardType.Attack, value: 8, essenceCost: 10, subType: 'Armory', faceSlug: 'sword-of-revenge' }),
  ...Array(1).fill({ type: CardType.Attack, value: 3, essenceCost: 5, subType: 'Armory', playableAfterPass: true, faceSlug: 'paladins-hammer' }),
  ...Array(1).fill({ type: CardType.Attack, value: 2, essenceCost: 2, subType: 'Spell', faceSlug: 'fireball' }),
  ...Array(1).fill({ type: CardType.StealTower, value: 1, essenceCost: 5, subType: 'Spell', faceSlug: 'purification' }),
  ...Array(1).fill({ type: CardType.PsySearch, value: 3, essenceCost: 3, subType: 'Spell', faceSlug: 'card-cyclone' }),
  ...Array(1).fill({ type: CardType.LifeDrain, value: 2, essenceCost: 4, subType: 'Spell', faceSlug: 'life-drain' }),
  ...Array(1).fill({ type: CardType.Counterblast, value: 1, essenceCost: 3, subType: 'Spell', extendedShield: true, faceSlug: 'counterblast' }),
  ...Array(1).fill({ type: CardType.EyesOfMadness, value: 1, essenceCost: 5, subType: 'Spell', faceSlug: 'eyes-of-madness' }),
  ...Array(1).fill({ type: CardType.Frost, value: 1, essenceCost: 3, subType: 'Spell', faceSlug: 'frost' }),
  ...Array(1).fill({ type: CardType.Invincible, value: 1, essenceCost: 3, subType: 'Spell', extendedShield: true, faceSlug: 'invincible' }),
  ...Array(1).fill({ type: CardType.NaturalGrip, value: 2, essenceCost: 4, subType: 'Spell', faceSlug: 'natural-grip' }),
  ...Array(1).fill({ type: CardType.Steal, value: 1, essenceCost: 3, subType: 'Spell', extendedShield: true, playableAfterPass: true, faceSlug: 'shadow-burglary' }),
  ...Array(1).fill({ type: CardType.TwilightShift, value: 0, essenceCost: 4, subType: 'Spell', faceSlug: 'twilight-shift' }),
  ...Array(1).fill({ type: CardType.ThunderSprint, value: 5, essenceCost: 4, subType: 'Spell', faceSlug: 'thunder-sprint' }),
  ...Array(1).fill({ type: CardType.Trembling, value: 0, essenceCost: 7, subType: 'Spell', faceSlug: 'trembling' }),
  ...Array(1).fill({ type: CardType.PlantedBomb, value: 5, essenceCost: 8, subType: 'Artifact', extendedShield: true, faceSlug: 'planted-bomb' }),
  ...Array(1).fill({ type: CardType.Protector, value: 2, essenceCost: 4, subType: 'Artifact', extendedShield: true, playableAfterPass: true, faceSlug: 'protector' }),
  ...Array(1).fill({ type: CardType.BodyUpgrade, value: 5, essenceCost: 8, subType: 'Artifact', faceSlug: 'body-upgrade' }),
  ...Array(1).fill({ type: CardType.FortunesFavor, value: 1, essenceCost: 4, subType: 'Artifact', faceSlug: 'fortunes-favor' }),
  ...Array(1).fill({ type: CardType.ArcaneBoots, value: 2, essenceCost: 2, subType: 'Artifact', faceSlug: 'arcane-boots' }),
  ...Array(1).fill({ type: CardType.DiscerningEye, value: 1, essenceCost: 4, subType: 'Artifact', faceSlug: 'discerning-eye' }),
  ...Array(1).fill({ type: CardType.BrokenSecret, value: 1, essenceCost: 4, subType: 'Artifact', faceSlug: 'broken-secret' }),
  ...Array(1).fill({ type: CardType.CursedIron, value: 1, essenceCost: 6, subType: 'Artifact', faceSlug: 'cursed-iron' }),
  ...Array(1).fill({ type: CardType.Ale, value: 4, essenceCost: 6, subType: 'Artifact', faceSlug: 'ale' }),
  ...Array(1).fill({ type: CardType.LifeCharger, value: 1, essenceCost: 16, subType: 'Artifact', extendedShield: true, faceSlug: 'life-charger' }),
  ...Array(1).fill({ type: CardType.MadnessControl, value: 4, essenceCost: 14, subType: 'Artifact', faceSlug: 'madness-control' }),
  ...Array(1).fill({ type: CardType.SealOfSilence, value: 0, essenceCost: 6, subType: 'Artifact', extendedShield: true, playableAfterPass: true, faceSlug: 'seal-of-silence' }),
  ...Array(1).fill({ type: CardType.VoodooDoll, value: 1, essenceCost: 6, subType: 'Artifact', faceSlug: 'voodoo-doll' }),
]

export const getCardDisplayName = (
  type: CardType,
  value?: number,
  subType?: string,
  faceSlug?: string,
  lang: Language = 'en',
): string => {
  if (subType === 'Armory' || subType === 'Artifact' || subType === 'Spell') {
    if (faceSlug) {
      const key = `card.${faceSlug}.name`
      const translated = t(key, lang)
      if (translated !== key) return translated
    }
  }

  const typeMap: Partial<Record<CardType, string>> = {
    [CardType.Attack]: 'term.attack',
    [CardType.Pushback]: 'term.pushback',
    [CardType.Defense]: 'term.defense',
    [CardType.Heal]: 'term.heal',
    [CardType.Disease]: 'term.disease',
    [CardType.PsySearch]: 'term.psy-search',
    [CardType.PsyBlock]: 'term.psy-block',
    [CardType.Steal]: 'term.steal',
    [CardType.DoubleCross]: 'term.double-cross',
    [CardType.Shock]: 'term.shock',
    [CardType.Energize]: 'term.energize',
    [CardType.Hibernation]: 'term.hibernation',
    [CardType.Dispel]: 'term.dispel',
  }

  if (typeMap[type]) {
    return t(typeMap[type]!, lang)
  }

  return String(type)
    .split('_')
    .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ')
}
